<template>
    <div v-loading.fullscreen.lock="fullscreenLoading">
        <!-- 检索条件 -->
        <div>
            <el-form :inline="true" @submit.native.prevent>
                <el-row>
                    <el-form-item :label="item.fieldShow + ':'" v-for="(item, index) in searchTermList" :key="index" v-show="item.isShow">
                        <el-input style="width:200px" v-if="item.fieldType == 'string' && item.isShow" @keyup.enter.prevent="toClick(item.fieldEntity)" @blur="inblur" @focus="infocus"
                            @change="((val) => { handleChange(val, item.fieldEntity) })" :placeholder="'请输入' + item.fieldShow" v-model.trim="queryMap[item.fieldEntity]" size="mini">
                        </el-input>
                        <el-date-picker v-else-if="item.fieldType == 'date' && item.isShow" @change="((val) => { handleChange(val, item.fieldEntity) })" size="mini" v-model="queryMap[item.fieldEntity]" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
                            type="date" placeholder="选择日期">
                        </el-date-picker>
                        <el-input style="width:200px" v-else-if="item.fieldType == 'number' && item.isShow" @keyup.enter.prevent="toClick(item.fieldEntity)" @blur="inblur" @focus="infocus"
                            @change="((val) => { handleChange(val, item.fieldEntity) })" :placeholder="'请输入' + item.fieldShow" v-model.number="queryMap[item.fieldEntity]" size="mini">
                        </el-input>
                        <el-select size="mini" v-else-if="item.fieldType == 'formatter' && item.isShow" @keyup.enter.prevent="toClick(item.fieldEntity)" @blur="inblur" @focus="infocus"
                            @change="((val) => { handleChange(val, item.fieldEntity) })" v-model="queryMap[item.fieldEntity]" placeholder="请选择">
                            <el-option v-for="matItem in JSON.parse(item.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <!-- 表格 -->
        <el-table show-summary :summary-method="getSummaries" tooltip-effect="dark" ref="moviesTable" height="420" size="mini" @selection-change="handleSelectionChange" style="width: 100%" :data="tableData" border stripe
            highlight-current-row :header-cell-style="getHeaderCellStyle">
            <el-table-column type="selection" width="50" :selectable="selectEnable" disabled="true">
            </el-table-column>
            <template v-for="(item, index) in Columns">
                <!-- 数字 -->
                <el-table-column v-if="item.fieldType == 'formatter' && item.isShow" align="center" :key="index" :min-width="item.width || 120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
                    :show-overflow-tooltip="true">
                    <!-- 各种状态判断 -->
                    <template slot-scope="scope">
                        <el-tag size="mini" type="primary">
                            {{ JSON.parse(item.formatterContent)[scope.row[item.fieldEntity]].value }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column v-else-if="item.fieldType == 'string' && item.isShow" align="center" :key="index + 'a'" :min-width="item.width || 120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
                    :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column v-else-if="item.fieldType == 'number' && item.isShow" align="center" :key="index + 'b'" :min-width="item.width || 120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
                    :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column v-else-if="item.fieldType == 'date' && item.isShow" align="center" :key="index + 'c'" :min-width="item.width || 120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
                    :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ $common.getLocalTime(scope.row[item.fieldEntity]) }}</span>
                    </template>
                </el-table-column>
            </template>
        </el-table>
        <!-- 分页 -->
        <el-pagination v-if="isPagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" background :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>

    </div>
</template>
<script>
import { isDate } from "moment";
import NP from "number-precision";
export default {
    name: "SearchSchemeMultiple",
    components: {},
    data() {
        return {
            ormId: '',
            currentPage: 1,
            pageSizes: [10, 25, 50, 100],
            pageSize: 10,
            total: 0,
            tableData: [],
            isPagination: "",
            queryMap: {},
            searchTermList: [], //检索条件
            Columns: [],
            multipleSelection: [],
            fullscreenLoading: false
        };
    },

    props: {
        id: {
            type: [Number, String],
            require: true,
        },
        parentSearchData: {
            type: Object,
            require: false
        },
        parentData: {//选中的数据
            type: Object,
            require: false
        },
        isDate: {//判断是否给时间查询设置默认值
            type: Boolean,
            require: false
        },
    },
    watch: {},
    computed: {},
    mounted() {
        addEventListener('keydown', this.keyUpChild)
    },
    beforeDestroy() {
        removeEventListener('keydown', this.keyUpChild)
    },
    created() {
        this.fullscreenLoading = true
        if (this.id == '' || this.id == null || this.id == 'null') {
            this.fullscreenLoading = false
            return this.$message({
                type: "error",
                message: "查询异常",
            });
        }
        // 处理组件需要的数据
        let ormId = JSON.parse(sessionStorage.getItem("loginInfo")).ormId
        this.$dbCache.Record_Get(this.id).then(async (val) => {
            let searchPlan = val
            // 当searchPlan为null或undefined时,重新调用searchQuery
            if (!searchPlan) {
                searchPlan = await this.searchQuery();
            }
            let {
                pageCount, //分页条目
                isPagination, // 是否分页
                conditionList, // 检索条件
                tableList, // 表格头
                width, // 宽
                searchName, //title标题
            } = searchPlan;
            conditionList.forEach((item) => {
                item.value = "";
                item.isShow == 1 ? (item.isShow = true) : (item.isShow = false);
            });
            tableList.forEach((item) => {
                item.isShow == 1 ? (item.isShow = true) : (item.isShow = false);
                item.isSort == 1 ? (item.isSort = true) : (item.isSort = false);
            });
            console.log(searchName);
            this.$emit("getWidth", '90');
            this.$emit("sendTitle", searchName);
            if (pageCount) {
                this.pageSizes = pageCount.split(",").map(item => Number(item))
            } else {
                this.pageSizes = [10, 25, 50, 100]
            }
            this.Columns = tableList;
            this.searchTermList = conditionList;
            this.isPagination = isPagination == 0 ? false : true; //是否分页
            // 根据返回数据处理一些页面逻辑
            this.pageSize = parseInt(this.pageSizes[0]);
            if (this.isPagination == true) {
                // 需要分页
                this.queryMap = {
                    searchPlanId: this.id,
                    page: this.currentPage,
                    rows: this.pageSize,
                };
                // 添加请求参数
                this.searchTermList.forEach((item) => {
                    if (this.isDate && item.fieldType == 'date') {
                        if (item.fieldEntity == "start") {
                            this.$set(this.queryMap,item.fieldEntity,new Date(new Date().toLocaleDateString()).getTime() - 1 * 24 * 3600 * 1000)
                        } else if (item.fieldEntity == "end") {
                            this.$set(this.queryMap,item.fieldEntity,new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
                        } else {
                            this.$set(this.queryMap,item.fieldEntity,"")
                        }
                    } else {
                        if (this.parentSearchData[item.fieldEntity] || this.parentSearchData[item.fieldEntity] === 0) {
                            this.$set(this.queryMap,item.fieldEntity,this.parentSearchData[item.fieldEntity])
                        } else {
                            this.$set(this.queryMap,item.fieldEntity,"")
                        }
                    }
                });
                this.queryMap.ormId = ormId
                if (this.queryMap.hasOwnProperty("unitId")) {
                    this.queryMap.unitId = this.parentSearchData.smId;
                }
                if (this.queryMap.hasOwnProperty("opmBuyer")) {
                    this.queryMap.opmBuyer = 1;
                }
                // if (this.queryMap.hasOwnProperty("smId")) {
                //   this.queryMap.smId = this.parentSearchData.smId;
                // }
                if (this.queryMap.hasOwnProperty("ormId")) {
                    this.queryMap.ormId = ormId
                }
            } else {
                this.queryMap = {
                    searchPlanId: this.id,
                };
                this.searchTermList.forEach((item) => {
                    if (this.isDate && item.fieldType == 'date') {
                        if (item.fieldEntity == "start") {
                            this.$set(this.queryMap,item.fieldEntity,new Date(new Date().toLocaleDateString()).getTime() - 1 * 24 * 3600 * 1000)
                        } else if (item.fieldEntity == "end") {
                            this.$set(this.queryMap,item.fieldEntity,new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
                        } else {
                            this.$set(this.queryMap,item.fieldEntity,"")
                        }
                    } else {
                        if (this.parentSearchData[item.fieldEntity] || this.parentSearchData[item.fieldEntity] === 0) {
                            this.$set(this.queryMap,item.fieldEntity,this.parentSearchData[item.fieldEntity])
                        } else {
                            this.$set(this.queryMap,item.fieldEntity,"")
                        }
                    }
                });
                this.queryMap.ormId = ormId
                if (this.queryMap.hasOwnProperty("unitId")) {
                    this.queryMap.unitId = this.parentSearchData.smId;
                }
                if (this.queryMap.hasOwnProperty("opmBuyer")) {
                    this.queryMap.opmBuyer = 1;
                }
                // if (this.queryMap.hasOwnProperty("smId")) {
                //   this.queryMap.smId = this.parentSearchData.smId;
                // }
                if (this.queryMap.hasOwnProperty("ormId")) {
                    this.queryMap.ormId = ormId
                }
            }
            this.getTableList(this.queryMap)
        })
    },
    methods: {
        async searchQuery() {
            const res = await this.$http.searchQuerySearchPlanById({ ids: [this.id] })
            if (res.status == 200) {
                return res.result
            } else {
                this.$message.error(res.message)
                return {}
            }
        },
        toClick(e) {
            this.searchData()
            this.$nextTick(() => {
                this.$refs[e][0].blur()
            })
            // document.getElementById("btn").click()
        },
        inblur() {
            this.$nextTick(() => {
                addEventListener('keydown', this.keyUpChild)
            })
        },
        infocus() {
            removeEventListener('keydown', this.keyUpChild)
        },
        getSummaries(param) {
            const list = this.multipleSelection.map(item => item.businessId) || []
            let { columns, data } = param;

            data = data.filter(item => list.includes(item.businessId))
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                } else if (column.label == '余额') {
                    const num = data.map(item => item.oldBalance).reduce((prev, item) => NP.plus(Number(prev), Number(item)), 0)

                    return sums[index] = this.$common.getDecimalInfo(
                        3,
                        num
                    );
                } else if (column.label == '总金额') {
                    const num = data.map(item => item.totalMoney).reduce((prev, item) => NP.plus(Number(prev), Number(item)), 0)
                    return sums[index] = this.$common.getDecimalInfo(
                        3,
                        num
                    );
                } else if (column.label == '金额' || column.label == '总不含税金额') {
                    const num = data.map(item => item.money).reduce((prev, item) => NP.plus(Number(prev), Number(item)), 0)
                    return sums[index] = this.$common.getDecimalInfo(
                        3,
                        num
                    );
                } else if (column.label == '含税金额') {
                    const num = data.map(item => item.psmoney).reduce((prev, item) => NP.plus(Number(prev), Number(item)), 0)
                    return sums[index] = this.$common.getDecimalInfo(
                        3,
                        num
                    );
                } else {
                    return sums[index] = ''
                }
            });
            return sums;
        },
        // openKeyup() {
        //   addEventListener('keydown', this.keyUpChild)
        // },
        keyUpChild(e) {
            console.log(e.keyCode);
            if (e.keyCode == 13) {
                this.tableData.forEach((item) => {
                    this.$refs.moviesTable.toggleRowSelection(item, true);
                })
                this.$nextTick(() => {
                    this.$parent.$parent.getSelect()
                })
            }
        },
        //默认勾选禁用状态
        selectEnable(row, rowIndex) {
            if (this.parentData && this.parentData.list.length > 0) {
                var flag = false
                this.parentData.list.forEach(item => {
                    if (item.businessType == '采购订单') {
                        if (row[this.parentData.type1] == item[this.parentData.type1]) {
                            flag = true
                        }
                    } else if (item.businessType == '采购退补') {
                        if (row[this.parentData.type] == item[this.parentData.type]) {
                            flag = true
                        }
                    }

                })
                if (flag) {
                    return false
                }
            }
            return true
        },
        // 勾选明细
        handleSelectionChange(val) {
            this.multipleSelection = val;
            if (this.parentData && this.parentData.list.length > 0) {
                this.tableData.forEach(item => {
                    this.parentData.list.forEach(item1 => {
                        if (item.businessType == '采购订单') {
                            if (item[this.parentData.type1] == item1[this.parentData.type1]) {
                                this.$refs.moviesTable.toggleRowSelection(item, true);
                            }
                        } else if (item.businessType == '采购退补') {
                            if (item[this.parentData.type] == item1[this.parentData.type]) {
                                this.$refs.moviesTable.toggleRowSelection(item, true);
                            }
                        }
                    })
                })
                if (this.multipleSelection.length > 0) {
                    this.parentData.list.forEach(item1 => {
                        this.multipleSelection.forEach((item, index) => {
                            if (item.businessType == '采购订单') {
                                if (item[this.parentData.type1] == item1[this.parentData.type1]) {
                                    this.multipleSelection.splice(index, 1)
                                }
                            } else if (item.businessType == '采购退补') {
                                if (item[this.parentData.type] == item1[this.parentData.type]) {
                                    this.multipleSelection.splice(index, 1)
                                }
                            }
                        })
                    })
                    this.multipleSelection = this.multipleSelection.concat(this.parentData.list)
                } else {
                    this.multipleSelection = this.parentData.list
                }
            }
            this.$emit("selection", this.multipleSelection)
        },
        // 双击确认
        // handleSelectClick(row, column, event) {
        //   this.$emit("TranData", row);
        // },
        handleChange(value, name) {
            // value默认参，name当前所需的name
            this.queryMap[name] = value;
        },
        //   查询
        searchData() {
            this.currentPage = 1;
            this.queryMap.page = 1;
            this.getTableList(this.queryMap);
        },
        // 查询弹窗表格
        async getTableList(params) {
            let res = await this.$http.querySearchPlanEntityVo(params);
            this.total = res.total;
            this.tableData = res.rows;
            this.fullscreenLoading = false
            this.$nextTick(() => {
                this.$refs.moviesTable.doLayout();
            })
            if (this.parentData && this.parentData.list.length > 0) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.tableData.forEach(item => {
                            this.parentData.list.forEach(item1 => {
                                if (item.businessType == '采购订单') {
                                    if (item[this.parentData.type1] == item1[this.parentData.type1]) {
                                        this.$refs.moviesTable.toggleRowSelection(item, true);
                                    }
                                } else if (item.businessType == '采购退补订单') {
                                    if (item[this.parentData.type] == item1[this.parentData.type]) {
                                        this.$refs.moviesTable.toggleRowSelection(item, true);
                                    }
                                }
                            })
                        })
                        this.multipleSelection = this.parentData.list
                        this.$nextTick(() => {
                            this.$refs.moviesTable.doLayout();
                        })
                    }, 100)
                })
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryMap.rows = val;
            this.getTableList(this.queryMap);
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryMap.page = val;
            this.getTableList(this.queryMap);
        },
        //   -----------------------------------------------------
        getHeaderCellStyle() {
            return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
        },
    },
};
</script>
<style scoped>
.el-pagination {
    padding: 20px 0px 5px;
}
</style>